<template>
  <v-badge :offset-y="6" :offset-x="6" dot :model-value="showBadge" color="primary">
    <v-btn
      ref="buttonRef"
      elevation="0"
      rounded
      height="32"
      class="text-body-1 font-weight-bold text-medium-emphasis"
      :tabindex="tabindex"
      :to="menuItem.link"
      :active="isActive"
      @click="trackEvent(menuItem.event)"
    >
      {{ menuItem.text.toUpperCase() }}
    </v-btn>
  </v-badge>
</template>

<script setup lang="ts">
import { MenuItem } from '@/components/navigation/menu'
import { trackEvent } from '@/modules/tracking/useTracking'
import { VueInstance } from '@vueuse/core'
import { computed, PropType, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  menuItem: {
    type: Object as PropType<MenuItem>,
    required: true
  },
  isSelected: {
    type: Boolean,
    default: false
  },
  tabindex: {
    type: Number,
    default: -1
  }
})

const currentRoute = useRoute()

if (props.menuItem.count) {
  props.menuItem.count.loadFunction()
}

const showBadge = computed(
  () => props.menuItem.count != undefined && props.menuItem.count.getter() > 0
)

const isActive = computed<boolean>(() => {
  return currentRoute && currentRoute.path.includes(props.menuItem.link)
})

const buttonRef = ref<VueInstance | null>(null)

watch(
  () => props.isSelected,
  () => {
    if (props.isSelected) {
      buttonRef.value?.$el.focus()
    } else {
      buttonRef.value?.$el.blur()
    }
  }
)
</script>

<style lang="scss" scoped>
.v-btn--active.v-btn.v-btn--rounded {
  color: rgb(var(--v-theme-primary)) !important;
}
</style>
